import React from "react";
import { ArrowUpRight } from "lucide-react";

interface FilepathLinkProps {
  onClick: () => void;
  className?: string;
  ariaLabel?: string;
  tooltipContent?: string;
}

export const FilepathLink: React.FC<FilepathLinkProps> = ({
  onClick,
  className = "",
  ariaLabel = "Open file",
  tooltipContent,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <ArrowUpRight
      className={`size-3.5 opacity-70 transition-all duration-200 text-secondary-n-400 hover:text-white cursor-pointer focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${className}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      aria-label={ariaLabel}
      tabIndex={0}
      data-tooltip-id="tooltip"
      data-tooltip-content={tooltipContent}
      data-tooltip-place="top"
    />
  );
};
